import React, { useEffect, useMemo, useState } from 'react';
import ChartCard from '../charts/ChartCard';
import { LineChart, EmptyChart } from '../charts/AnalyticsCharts';

export default function CourseToggleTrendCard({
  title = 'Course Comparison Trend',
  subtitle,
  icon = 'bi-graph-up-arrow',
  iconColor = '#3b82f6',
  series = [],
  onClick,
}) {
  const [selectedIds, setSelectedIds] = useState([]);

  useEffect(() => {
    const topIds = series.slice(0, 5).map((item) => item.courseId);
    setSelectedIds((current) => {
      const existing = current.filter((id) => series.some((item) => item.courseId === id));
      return existing.length ? existing : topIds;
    });
  }, [series]);

  const selectedSeries = useMemo(
    () => series.filter((item) => selectedIds.includes(item.courseId)),
    [series, selectedIds],
  );

  const labels = selectedSeries[0]?.points?.map((point) => point.label) || [];
  const datasets = selectedSeries.map((item) => ({
    label: item.courseName,
    data: item.points.map((point) => point.value),
    color: item.color,
    fill: false,
    pointRadius: 3,
  }));

  const toggle = (courseId) => {
    setSelectedIds((current) => (
      current.includes(courseId)
        ? current.filter((id) => id !== courseId)
        : [...current, courseId]
    ));
  };

  return (
    <ChartCard
      title={title}
      subtitle={subtitle}
      icon={icon}
      iconColor={iconColor}
      onClick={onClick}
      bodyStyle={{
        background: `linear-gradient(180deg, ${iconColor}12 0%, rgba(255,255,255,0.96) 72%)`,
        border: `1px solid ${iconColor}22`,
        borderRadius: 12,
        padding: 14,
      }}
    >
      <div className="d-flex flex-wrap gap-2 mb-3">
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={(e) => { e.stopPropagation(); setSelectedIds(series.map((item) => item.courseId)); }}>All</button>
        <button type="button" className="btn btn-sm btn-outline-secondary" onClick={(e) => { e.stopPropagation(); setSelectedIds([]); }}>Clear</button>
        {series.map((item) => {
          const active = selectedIds.includes(item.courseId);
          return (
            <button
              key={item.courseId}
              type="button"
              className={`btn btn-sm ${active ? 'btn-primary' : 'btn-outline-primary'}`}
              onClick={(e) => { e.stopPropagation(); toggle(item.courseId); }}
              style={active ? { backgroundColor: item.color, borderColor: item.color } : undefined}
            >
              {item.courseName}
            </button>
          );
        })}
      </div>
      {selectedSeries.length ? (
        <LineChart
          height={260}
          labels={labels}
          datasets={datasets}
          yMin={0}
        />
      ) : (
        <EmptyChart label="course comparison" themeColor={iconColor} />
      )}
    </ChartCard>
  );
}
